
import { Lock, Mail, Building2, ArrowRight, Shield, ArrowLeft } from "lucide-react";
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import "./index.css";
import Keyboard from 'react-simple-keyboard';
import 'react-simple-keyboard/build/css/index.css';
import React, { useContext, useEffect, useRef, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import { UserContext } from "../../context/UserContext";
import axios from "axios";
import { baseServiceUrl, urls } from "../../environment";
import PageLoader from "../../components/Loader/PageLoader";
import "react-simple-keyboard/build/css/index.css";
import PasswordSuggestion from "./PasswordSuggestion";
import {
  decryptAES256CBC,
  decryptAES256CBC2,
  decryptWithFixedKey,
  encryptWithFixedKey,
  generateRandomBytes
} from "../../utils";
import useUserStore from "../../stores/useUserStores";
import { VirtualKeyboard } from "./VirtualKeyboard";
const Login = () => {
  const keyboardRef = useRef<any>();
  const [username, setusername] = useState("");
  const [keyboardType, setKeyboardType] = useState<"email" | "password">(
    "email"
  );
  const [KeyboardLayout, setKeyboardLayout] = useState("default");
  const [password, setpassword] = useState("");
  const errornotify = (msg: any) => toast.error(msg);
  const [loginbtn, setloginbtn] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
 

  const { setuserdetail, setisAdmin, setToken, setFullScreenMode, setislogin } =
    useUserStore();
  const nav = useNavigate();
  const [orgOptions, setOrgOptions] = useState<any[]>([]);
  const [selectedOrg, setSelectedOrg] = useState<string | null>(null);
  const [pwdfield, setpwdfield] = useState(false);
  const tryNext = async () => {
    const email = username.trim().toLowerCase();

    if (!email) {
      errornotify("Email is required");
      setloginbtn(false);
      return;
    }

    const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    if (!isValidEmail) {
      errornotify("Please enter a valid email address");
      setloginbtn(false);
      return;
    }

    setloginbtn(true);

    try {
      const response = await axios.post(
        baseServiceUrl + urls.loginUserTypesByEmail,
        {
          email,
          is_examinee: 1,
        }
      );
      setpwdfield(true);
      if (Array.isArray(response.data) && response.data.length > 0) {
        setOrgOptions(response.data);
      }
    } catch (err: any) {
      console.error("API Error >>", err);

      errornotify(
        err?.response?.data?.message ||
          err?.message ||
          "Unexpected error. Please try again."
      );
    } finally {
      setloginbtn(false);
    }
  };
  const tryLogin = async () => {
    setloginbtn(true);
    // if(browserName!=="Chrome"){
    //   errornotify("It looks like you're using a different browser. Please switch to Google Chrome to access this app.");
    //   setloginbtn(false);
    //   return;
    // }
    if (username === "" || password === "") {
      errornotify("All fields are required");
      setloginbtn(false);
      return;
    }
    try {
      const encryption_key = generateRandomBytes();
      const payload = encryptWithFixedKey({
        user: {
          email: username?.toLowerCase(),
          password: password,
          org_id: !!selectedOrg ? +selectedOrg : null,
          user_type: "USER",
        },
        encryption_key,
      });

      // const response = await axios.post(baseServiceUrl + urls.adminLoginUrl, {
      //   user: {
      //     email: username,
      //     password: password,
      //     org_id: !!selectedOrg ? +selectedOrg : null,
      //     user_type: "USER",
      //   },
      // });
      const response = await axios.post(
        baseServiceUrl + urls.adminLoginUrl,
        payload
      );
      if (!!response && response.data) {
        const rawResponse = await decryptAES256CBC2(
          response.data?.response,
          btoa(encryption_key)
        );
        const responsedData = JSON.parse(rawResponse);
        if (responsedData?.user?.userType !== "USER")
          throw new Error("Invalid User");
        if (!("Notification" in window)) {
        } else {
          Notification.requestPermission();
        }
        setuserdetail(responsedData.user);
        setToken(responsedData.user.token);
        setislogin(true);
        setisAdmin(false);
        // enterFullscreen();
        setTimeout(() => {
          nav("/dashboard/my-exams");
        }, 500);
      } else {
        setloginbtn(false);
      }
    } catch (err: any) {
      console.log("err >> ", err);

      errornotify(
        err?.response?.data?.message ||
          (err && err?.message) ||
          "Error encounter. Please try again."
      );
      setloginbtn(false);
    }
    // setislogin(true);
    //
  };
  // const enterFullscreen = () => {
  //   const element = document?.documentElement;
  //   if (element.requestFullscreen) {
  //     element.requestFullscreen();
  //     //@ts-ignore
  //   } else if (element.mozRequestFullScreen) {
  //     //@ts-ignore
  //     element.mozRequestFullScreen();
  //     //@ts-ignore
  //   } else if (element.webkitRequestFullscreen) {
  //     //@ts-ignore
  //     element.webkitRequestFullscreen();
  //     //@ts-ignore
  //   } else if (element.msRequestFullscreen) {
  //     //@ts-ignore
  //     element.msRequestFullscreen();
  //   }
  //   // setFullScreenMode(true);
  // };

  const onKeyboardChange = (input: any) => {
    if (keyboardType === "email") {
      setusername(input);
    } else if (keyboardType === "password") {
      setpassword(input);
    }
    // console.log("Input changed", input);
  };

  const handleShift = () => {
    const newLayoutName = KeyboardLayout === "default" ? "shift" : "default";
    setKeyboardLayout(newLayoutName);
  };
  const onKeyPressForKeyboard = (button: any) => {
    if (button === "{shift}" || button === "{lock}") handleShift();
  };
    const handleKeyPress = (key: string) => {
    if (keyboardType === 'email') {
      setusername(prev => prev + key);
    } else {
      setpassword(prev => prev + key);
    }
  };
    const handleBackspace = () => {
    if (keyboardType === "email") {
      setusername(prev => prev.slice(0, -1));
    } else {
      setpassword(prev => prev.slice(0, -1));
    }
  };
    const handleSpace = () => {
    if (keyboardType === 'email') {
      setusername(prev => prev + ' ');
    } else {
      setpassword(prev => prev + ' ');
    }
  };

    const handleEnter = () => {
    if (keyboardType === 'email') {
      setusername('password');
    } else {
      // handleLogin();
    }
  };


  useEffect(()=>{
    if(!pwdfield){
      setpassword("")
    }

  },[pwdfield])

    return (
    <>
      {/* <Toaster position="top-right" reverseOrder={false} /> */}
      <section className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 flex justify-center items-center ">
        <PageLoader loading={loginbtn} />
        
        <div className="w-full max-w-md lg:max-w-4xl">
          {/* Header */}
          <div className="text-center mb-3">
            
            <h1 className="text-3xl font-bold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent">
              Welcome Back
            </h1>
            <p className="text-gray-600 mt-0">Sign in to your account to continue</p>
          </div>

          {/* Login Form */}
          <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
        
            <div className=" px-5 mt-6">
              {
                pwdfield ?(
                              <div className="space-x-2 flex items-center group  ">
              <ArrowLeft className="text-4xl  text-gray-500 cursor-pointer" onClick={()=>setpwdfield(false)} />
              <p className="text-sm text-gray-500 group-hover:underline cursor-pointer" onClick={()=>setpwdfield(false)}>Go Back</p>
              </div>

                ):(
                  <></>
                )
              }
  
              <div className="space-y-6 mt-5">
                {/* Email Field */}
                {!pwdfield && (
                  <div className="space-y-2">
                    <label
                      htmlFor="username"
                      className="block text-sm font-semibold text-gray-700 flex items-center"
                    >
                      <Mail className="w-4 h-4 mr-2 text-blue-600" />
                      Email Address
                    </label>
                    <div className="relative">
                      <input
                        type="email"
                        id="email"
                        autoFocus
                        name="email"
                        autoComplete="off"
                        placeholder="example@gmail.com"
                        onFocus={() => {
                          setKeyboardType("email");
                          if (keyboardRef?.current) keyboardRef?.current?.setInput?.("");
                        }}
                        onChange={(e) => {
                          setusername(e.target.value);
                        }}
                        onCopy={(e) => e.preventDefault()}
                        onCut={(e) => e.preventDefault()}
                        onPaste={(e) => e.preventDefault()}
                        value={username}
                        className="w-full bg-gray-50 border border-gray-200 text-gray-900 rounded-xl px-4 py-3 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 hover:border-gray-300"
                        required
                      />
                    </div>
                  </div>
                )}

                {/* Organization Selection */}
                {orgOptions.length > 0 && (
                  <div className="space-y-2 animate-fadeIn">
                    <label
                      htmlFor="orgSelect"
                      className="block text-sm font-semibold text-gray-700 flex items-center"
                    >
                      <Building2 className="w-4 h-4 mr-2 text-blue-600" />
                      Select Organization
                    </label>
                    <select
                      id="orgSelect"
                      value={selectedOrg ?? ""}
                      onChange={(e) => setSelectedOrg(e.target.value)}
                      className="w-full bg-gray-50 border border-gray-200 text-gray-900 rounded-xl px-4 py-3 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 hover:border-gray-300"
                    >
                      <option value="" disabled>
                        -- Choose Organization --
                      </option>
                      {orgOptions.map((org) => (
                        <option key={org.org_id} value={org.org_id}>
                          {org.org_name}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                {/* Password Field with Suggestion */}
                {pwdfield && (
                  <div className="space-y-4 animate-slideIn">
                    <PasswordSuggestion />
                    
                    <div className="space-y-2">
                      <label
                        htmlFor="password"
                        className="block text-sm font-semibold text-gray-700 flex items-center"
                      >
                        <Lock className="w-4 h-4 mr-2 text-blue-600" />
                        Password
                      </label>
                      <div className="relative">
                        <input
                          type={showPassword ? "text" : "password"}
                          id="password"
                          onFocus={() => {
                            setKeyboardType("password");
                            if (keyboardRef?.current) keyboardRef.current.setInput("");
                          }}
                          name="password"
                          placeholder="Enter your password"
                          onChange={(e) => {
                            setpassword(e.target.value);
                            if (keyboardRef?.current)
                              keyboardRef.current.setInput(e.target.value);
                          }}
                          onCopy={(e) => e.preventDefault()}
                          onCut={(e) => e.preventDefault()}
                          onPaste={(e) => e.preventDefault()}
                          value={password}
                          className="w-full bg-gray-50 border border-gray-200 text-gray-900 rounded-xl px-4 py-3 pr-12 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 hover:border-gray-300"
                        />
                        <button
                          type="button"
                          onClick={() => setShowPassword((prev) => !prev)}
                          className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 transition-colors duration-200"
                          tabIndex={-1}
                        >
                          {showPassword ? (
                            <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                            </svg>
                          ) : (
                            <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.542-7a9.985 9.985 0 012.097-3.368m3.138-2.392A9.956 9.956 0 0112 5c4.477 0 8.268 2.943 9.542 7a9.973 9.973 0 01-4.293 5.255M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3l18 18" />
                            </svg>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                )}
        <VirtualKeyboard
          onKeyPress={handleKeyPress}
          onBackspace={handleBackspace}
          onEnter={handleEnter}
          onSpace={handleSpace}
        />
                {/* Virtual Keyboard */}
                {/* {
                  !pwdfield?(
                                <div className="hidden md:block bg-gray-50 rounded-xl p-4 border border-gray-200">
                  <div className="mb-2">
                    <p className="text-xs font-medium text-gray-600 flex items-center">
                      <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                      </svg>
                      Please Enter Your Registered Email ID
                    </p>
                  </div>
    
                </div>

                  ):(
                    <></>
                  )
                } */}
    

                {/* Submit Button */}
                <button
                  type="button"
                  onClick={pwdfield && password ? tryLogin : tryNext}
                  disabled={loginbtn}
                  className={`
                    w-full bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 
                    text-white font-semibold rounded-xl px-6 py-3 text-sm
                    transition-all duration-200 transform hover:scale-[1.02] hover:shadow-lg
                    disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none
                    flex items-center justify-center space-x-2
                    ${loginbtn ? 'animate-pulse' : ''}
                  `}
                >
                  {loginbtn ? (
                    <div className="flex items-center space-x-2">
                      <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                      <span>Processing...</span>
                    </div>
                  ) : (
                    <>
                      <span>{pwdfield && password ? "Sign In" : "Next"}</span>
                      <ArrowRight className="w-4 h-4" />
                    </>
                  )}
                </button>
              </div>
            </div>

            {/* Footer */}
            <div className="bg-gray-50 px-8 py-4 border-t border-gray-100">
              <p className="text-xs text-gray-500 text-center">
                Secure login powered by advanced encryption
              </p>
            </div>
          </div>

          {/* Additional Security Info */}
          <div className="mt-6 text-center">
            <p className="text-xs text-gray-500">
              Protected by enterprise-grade security measures
            </p>
          </div>
        </div>
      </section>

 
    </>
  );
};

export default Login;
